
import { VTabs } from "vuetify/lib";

export default VTabs.extend({
  name: "custom-tab",
  props: {
    showArrows: { type: Boolean, default: true },
  },
});
